<div>

    <rc-generic-button label="Add Donation" size="small" [classes]="['mb-3']" (click)="onAddDonation()" data-cy="btn-add-donation"/>

    <p-table 
        dataKey="id"
        [value]="donorDonations"
        styleClass="rc-datatable-outlined first-col-border last-col-border"
        [scrollable]="true"
        scrollHeight="400px"      
        [responsiveLayout]="'scroll'">

        <ng-template pTemplate="header">
            <tr>
                <th>Donation ID</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Is Refunded</th>
                <th>Is Pledged</th>
                <th>Campaign</th>
                <th>Fund Code</th>
                <th>Event Code</th>
                <th>Bundler ID</th>
                <th>Compliance Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-donationItem>
            <tr>
                <td>{{donationItem.donationId}}</td>
                <td>{{sharedService.shortDate(donationItem.date)}}</td>
                <td>{{donationItem.amount | currency: 'USD'}}</td>
                <td>{{donationItem.isRefunded}}</td>
                <td>{{donationItem.isPledged}}</td>
                <td>{{donationItem.campaignName}}</td>
                <td>{{donationItem.fundCode}}</td>
                <td>{{donationItem.eventCode}}</td>
                <td>{{donationItem.fundraiserId}}</td>
                <td>{{donationItem.correctiveActionType}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Add Donation MODAL -->
<div id="add-donation-donor-card" data-cy="add-donation-donor-card">
    <p-dialog [(visible)]="showAddDonationDialog"
        header="Add Donation" 
        [modal]="true"
        [maximizable]="true"
        styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300" >

    <!-- <app-donations-add>
    </app-donations-add> -->

    </p-dialog>
</div>
